export default __webpack_public_path__ + "static/media/Board_Meeting_Intimation_document.10f82630.pdf";